module.exports = __webpack_public_path__ + "static/media/edit-ic.6667022b.svg";